export default {
  name: 'Pill',
}
